import {Component, OnInit} from '@angular/core';
import {UntypedFormGroup} from "@angular/forms";
import {AlertService} from "../../../providers/service/alert.service";
import {Router} from "@angular/router";
import {UserService} from "../../../providers/service/user.service";
import {GlobalVariablesService} from "../../../providers/service/global-variables.service";

@Component({
    selector: 'app-recovery-password',
    templateUrl: './recovery-password.component.html',
    styleUrls: ['./recovery-password.component.scss'],
    standalone: false
})
export class RecoveryPasswordComponent implements OnInit {

    public userForm: UntypedFormGroup;
    public loading=false;

    constructor(
        private userService: UserService,
        private router: Router,
        private alertService: AlertService,
        private globalVariablesService: GlobalVariablesService
    ) {
        this.userForm = userService.getFormRecovery();
    }

    ngOnInit(): void {
    }

    get logo() {
        return this.globalVariablesService.defaultLogoPc
    }
    recovery() {
        this.loading = true;
        this.userService.recovery$(this.userForm.get('email')?.value).subscribe(()=>{
            this.loading = false;
            this.userForm.reset();
            this.router.navigate(['/auth/login']);
        },error => {
            this.loading = false;
            this.alertService.error(error);
        })
    }
}
